import React, { lazy, useEffect, Suspense } from 'react';

import { Box, useMediaQuery } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

import { PageLoader } from '@/components/Loaders/PageLoader';

import { MediaQueryAmountsEnum } from '@/enum/mediaQueryAmounts.enum';

import { removeHashFromPath } from '@/utils/removeHashFromPath';

import '../../App.css';

const ThreeStepSection = lazy(
  () => import('@/components/HomePage/ThreeStepSection'),
);

const SupportedCoinsSection = lazy(
  () => import('@/components/HomePage/SupportedCoinsSection'),
);

const SimpleStepsSection = lazy(
  () => import('@/components/HomePage/SimpleStepsSection'),
);

const ManagementSection = lazy(
  () => import('@/components/HomePage/ManagementSection'),
);

const FreeTrialSection = lazy(
  () => import('@/components/HomePage/FreeTrialSection'),
);

const FooterSection = lazy(() => import('@/components/HomePage/FooterSection'));

const FeeSection = lazy(() => import('@/components/HomePage/FeeSection'));

const FaqSection = lazy(() => import('@/components/HomePage/FaqSection'));

const DashboardSection = lazy(
  () => import('@/components/HomePage/DashboardSection'),
);

const AcceptPaymentsSection = lazy(
  () => import('@/components/HomePage/AcceptPaymentsSection'),
);

const AboutUsSection = lazy(
  () => import('@/components/HomePage/AboutUsSection'),
);

const AcceptCryptoPaymentsSection = lazy(
  () => import('@/components/HomePage/AcceptCryptoPaymentsSection'),
);

const ArrowScrollToTop = lazy(() => import('@/components/ArrowScrollToTop'));

const MainPage: React.FC = () => {
  const { pathname, hash, key } = useLocation();
  const [notADesktop] = useMediaQuery(MediaQueryAmountsEnum.isNotADesktop);

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
          removeHashFromPath();
        }
      }, 0);
    }
  }, [pathname, hash, key]);

  return (
    <Box>
      <Suspense fallback={<PageLoader />}>
        <FreeTrialSection />

        {notADesktop && <AcceptCryptoPaymentsSection />}

        <FeeSection />
        <ThreeStepSection />
        <DashboardSection />
        <SimpleStepsSection />
        <AcceptPaymentsSection />
        <SupportedCoinsSection />
        <FaqSection />
        <AboutUsSection />
        <ManagementSection />
        <FooterSection />

        <ArrowScrollToTop />
      </Suspense>
    </Box>
  );
};

export default MainPage;
